export default [
  {
    path: '/client/organization',
    meta: { auth: 'client' },
    component: () => import(/* webpackChunkName: "client-organization" */ "@/views/client/Organization.vue")
  }
];
